export const ctm = {
    data: {
        vertical: {
            car: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/ctm/images/ctm-logo-inline.svg',
                    header_logo_image_url_small: '/evt/assets/brand/ctm/images/ctm-logo-stacked.svg',
                    error_page_quote_something_went_wrong_image_url: '/evt/assets/brand/ctm/sergei-error.png',
                    quote_expired_screen_image_url: '/evt/assets/brand/ctm/images/alexander.png',
                    rego_lookup_loading_screen_hero_image_url: '/evt/assets/brand/ctm/images/alexander_half.png',
                    welcome_back_hero_image_url: '/evt/assets/brand/ctm/images/sergei_trumpet.png',
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_collection_notice_car.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: 'https://www.comparethemarket.com.au/car-insurance/disclosures/',
                    footer_disclaimer_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: null,
                    footer_copyright_banner_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.comparethemarket.com.au'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Compare the Market',
                    application_details_opt_in_checkbox_brand_name: 'Compare the Market',
                    rego_lookup_licence_plate_placeholder: '123CTM',
                    rego_lookup_default_licence_plate_state_label: 'Compare the market',
                    rego_lookup_welcome_message: "Welcome to Compare the Market. We're here to help you find a great deal on car insurance."
                }
            },
            home: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/ctm/images/ctm-logo-inline.svg',
                    header_logo_image_url_small: '/evt/assets/brand/ctm/images/ctm-logo-stacked.svg',
                    error_page_quote_something_went_wrong_image_url: '/evt/assets/brand/ctm/sergei-error.png',
                    shielded_thank_you_hero_image_url: '/evt/assets/brand/ctm/images/alexander_sergei.png',
                    welcome_back_hero_image_url: '/evt/assets/brand/ctm/images/sergei_trumpet.png',
                    price_confidence_banner_mobile_url: '/evt/assets/brand/ctm/images/price-confidence-banner-mobile.png',
                    price_confidence_banner_tablet_url: '/evt/assets/brand/ctm/images/price-confidence-banner-tablet.png',
                    price_confidence_banner_desktop_url: '/evt/assets/brand/ctm/images/price-confidence-banner-desktop.png'
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_collection_notice_home_contents.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: 'https://www.comparethemarket.com.au/home-contents-insurance/disclosures/',
                    footer_disclaimer_financial_services_guide_url: 'https://secure.comparethemarket.com.au/static/legal/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: null,
                    footer_copyright_banner_privacy_policy_url: 'https://secure.comparethemarket.com.au/static/legal/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://secure.comparethemarket.com.au/static/legal/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.comparethemarket.com.au'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Compare the Market',
                    application_details_opt_in_checkbox_brand_name: 'Compare the Market'
                }
            }
        },
        design_system: {
            everest: {
                brand_primary: '#1c3e94',
                brand_secondary: '#0db14b',
                brand_base: '#333333',
                feature_1: '#008284',
                feature_2: '#f49e1e',
                feature_3: '#ef5123',
                feature_4: '#ef425e',
                brand_primary_120: '#000e79',
                brand_primary_80: '#4965a9',
                brand_primary_60: '#778bbf',
                brand_primary_30: '#bbc5df',
                brand_primary_10: '#e9ecf5',
                brand_secondary_120: '#008d1b',
                brand_secondary_80: '#3dc16f',
                brand_secondary_60: '#6ed093',
                brand_secondary_30: '#b7e8c9',
                brand_secondary_10: '#e7f7ed',
                brand_base_120: '#000000',
                brand_base_80: '#666666',
                brand_base_60: '#999999',
                brand_base_20: '#dddddd',
                brand_base_10: '#f3f3f3',
                brand_base_0: '#ffffff',
                feature_1_120: '#006365',
                feature_1_80: '#339b9d',
                feature_1_60: '#66b4b5',
                feature_1_30: '#b3dada',
                feature_1_10: '#e6f3f3',
                feature_2_120: '#f18600',
                feature_2_80: '#f6b14b',
                feature_2_60: '#f8c578',
                feature_2_30: '#fce2bc',
                feature_2_10: '#fef5e9',
                feature_3_120: '#eb2500',
                feature_3_80: '#f2744f',
                feature_3_60: '#f5977b',
                feature_3_30: '#facbbd',
                feature_3_10: '#fdeee9',
                feature_4_120: '#d31130',
                feature_4_80: '#f2687e',
                feature_4_60: '#f58e9e',
                feature_4_30: '#fac7cf',
                feature_4_10: '#fdecef',
                body_color: '#333333',
                body_background_color: '#f3f3f3',
                validation_error_color: '#ef425e',
                validation_error_bg_color: '#fdecef',
                validation_success_color: '#0db14b',
                form_label_color: '#008284',
                color_border_default: '#dddddd',
                color_border_input_default: '#666666',
                modal_overlay_dark: 'rgba(0, 0, 0, 0.7)',
                modal_overlay_light: 'rgba(255, 255, 255, 0.3)',
                family_base: 'SourceSansPro, Helvetica, Arial, sans-serif',
                family_heading: 'SourceSansPro, Helvetica, Arial, sans-serif',
                medicare_green: '#b9f79e',
                medicare_blue: '#d4eef5',
                medicare_yellow: '#f7e97b',
                energy_secondary_button: '#0ec228',
                energy_secondary_button_120: '#0ea324',
                energy_primary_button: '#0ec228',
                energy_primary_button_120: '#0ea324',
                result_hint_yellow: '#f0e599',
                energy_feature_blue: '#001443',
                energy_label_highlight_blue: '#e7f2fd',
                progress_bar_inactive: '#dddddd',
                progress_bar_active: '#1c3e94',
                a_link: '#1c3e94',
                input_border_radius: '0px',
                next_button_border_radius: '1rem',
                handover_button_border_radius: '1rem',
                registration_number_border_color: '#1c3e94', // brand_primary
                radio_input_color: '#2968F8', // radio filter button results page
                radio_icon_color: '#1c3e94', // radio group icon color _feature-1
                call_options_icon_inactive: '#1c3e94',
                call_options_icon_active: '#008284',
                background_theme_color: '#1c3e93',
                font_40: '4rem',
                font_32: '3.2rem',
                font_24: '2.4rem',
                font_20: '2rem',
                font_18: '1.8rem',
                font_16: '1.6rem',
                font_14: '1.4rem',
                font_12: '1.2rem',
                font_10: '1rem'
            }
        }
    }
};
